import { ComponentBase, ConfigResponse } from './config.types'

export const getComponentSectionByType = (
  componentType: string,
  sectionType: string,
  config: ConfigResponse
): ComponentBase | undefined => {
  const component = Object.values(config.components).find((c) => c.type === componentType)

  if (!component?.sections) {
    return undefined
  }

  const section = Object.values(component.sections).find((s) => s.type === sectionType)

  if (!section) {
    return undefined
  }

  return section
}
